import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, inject, Inject } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, startWith, map } from 'rxjs';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { Item, Rules } from '../../pda/port-agent-form.model';
import { ToastrService } from 'ngx-toastr';
interface EmailDialogData {
  to?: string[];
  cc?: string[];
  body?: string;
  signatureText?: string;
  services?: Rules;
}
interface Service {
  SNO: number;
  code: string;
  total: number;
  service: string;
  purpose: string;
  pa_remark: string;
  meraki_feedback: string;
  meraki_remark_client: string;
  client_comment: string;
  client_option: string;
  info_msg: string;
  negotiate: string;
  agreed: string;
  subService: any[];
  isSubService: boolean;
  expanded: boolean;
  systemTotal: number;
  agreedOrNegotiate: string;
}
@Component({
  selector: 'app-approval-request-dialog',
  templateUrl: './approval-request-dialog.component.html',
  styleUrls: ['./approval-request-dialog.component.scss']
})
export class ApprovalRequestDialogComponent {
  private loader = inject(DisbursmentService);
  isLoading$ = this.loader.loading$;
  toEmailList: string[] = [];
  ccEmailList: string[] = [];
  bodyText: string = "";
  signatureText: string = "";
  displayedColumns: string[] = ['select', 'service', 'system', 'agent', 'request'];
  selectedToEmails: string[] = [];
  selectedCcEmails: string[] = [];
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  selectedAll: boolean = false;

  to = new FormControl('', [Validators.email]);
  cc = new FormControl('', [Validators.email]);
  body = new FormControl('', [Validators.required]);
  signatureData = sessionStorage.getItem('signature');
  meraki_comment_to_client = new FormControl('',);
  signature = new FormControl(this.signatureData != null ? this.signatureData : '');
  createServiceForm !: FormGroup
  services: Item[] = [];
  filteredToOptions!: Observable<string[]>;
  filteredCcOptions!: Observable<string[]>;
  datasource: any = [];
  update_signature = new FormControl('',);

  constructor(
    private dialogRef: MatDialogRef<ApprovalRequestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EmailDialogData,
    private fb: FormBuilder, private snackBar: ToastrService
  ) {
    this.toEmailList = data?.to || [];
    this.ccEmailList = data?.cc || [];
    this.bodyText = data?.body || '';
    this.signatureText = data?.signatureText || '';

    // Ensure `data.services` is a single `Rules` object and contains `items`
    if (data?.services?.items && Array.isArray(data.services.items)) {
      this.services = data.services.items;
    }

  }

  get servicesFormArray() {
    return (this.createServiceForm.get('services') as FormArray);
  }


  ngOnInit() {
    this.filteredToOptions = this.to.valueChanges.pipe(
      startWith(''),
      map(value => this.filterOptions(value || '', this.toEmailList)),
    );

    this.filteredCcOptions = this.cc.valueChanges.pipe(
      startWith(''),
      map(value => this.filterOptions(value || '', this.ccEmailList)),
    );

    this.createServiceForm = this.fb.group({
      services: this.fb.array([]),
    });

    if (this.services && Array.isArray(this.services)) {
      this.services.forEach(service => {
        this.addService(service);
      });
    }

  }

  addService(item: any) {
    const serviceGroup = this.fb.group({
      SNO: [item.SNO],
      code: [item.code],
      total: [item.total || 0],
      service: [item.service || ''],
      purpose: [item.purpose || ''],
      pa_remark: [item.pa_remark || ''],
      meraki_feedback: [item.meraki_feedback || '',],
      meraki_remark_client: [item.meraki_remark_client || ''],
      client_comment: [item.client_comment || ''],
      client_option: [item.client_option === "N" ? false : true],
      info_msg: [item.info_msg || ''],
      agreed: [item.agreed || 'N'],
      negotiate: [item.negotiate || 'N'],
      subService: [item.subService || []],
      expanded: [false],
      systemTotal: [item.systemTotal || 0],
      display_to_client: [item.display_to_client === "N" ? false : true]
    });
    this.servicesFormArray.push(serviceGroup);
    this.updateDataSource();
  }
  updateDataSource() {
    this.datasource = [];
    for (let service of this.servicesFormArray.controls) {
      this.datasource.push(service);

    };
  }



  private filterOptions(value: string, datasource: string[]): string[] {
    const filterValue = value.toLowerCase();
    return datasource.filter(option => option.toLowerCase().includes(filterValue));
  }

  private addEmailToSelection(email: string, targetArray: string[]): boolean {
    if (!email || targetArray.includes(email) || !this.isValidEmail(email)) {
      return false;
    }
    targetArray.push(email);
    return true;
  }

  private isValidEmail(email: string): boolean {
    return Validators.email({ value: email } as any) === null;
  }

  addToEmail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (this.addEmailToSelection(value, this.selectedToEmails)) {
      event.chipInput?.clear();
      this.to.setValue('');
    }
  }

  selectToEmail(event: any): void {
    const value = event.option?.viewValue;
    if (this.addEmailToSelection(value, this.selectedToEmails)) {
      this.to.setValue('');
    }
  }

  removeToEmail(email: string): void {
    this.selectedToEmails = this.selectedToEmails.filter(e => e !== email);
  }

  addCcEmail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (this.addEmailToSelection(value, this.selectedCcEmails)) {
      event.chipInput?.clear();
      this.cc.setValue('');
    }
  }

  selectCcEmail(event: any): void {
    const value = event.option?.viewValue;
    if (this.addEmailToSelection(value, this.selectedCcEmails)) {
      this.cc.setValue('');
    }
  }

  removeCcEmail(email: string): void {
    this.selectedCcEmails = this.selectedCcEmails.filter(e => e !== email);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onContinue(): void {
    if (!this.isFormValid()) {
      return;
    }
    const services = this.createServiceForm.value.services;
    const selectedServices = services.filter((service: any) => service.display_to_client);
    if (selectedServices.length === 0) {
      this.snackBar.error("Please select at least one service")
      return;
    }
    const formData = this.createServiceForm.value
    const clientServices = this.formatServiceData(formData);
    if (this.update_signature.value) {
      sessionStorage.setItem("signature", this.signature.value ?? '');
    }
    this.dialogRef.close({ to: this.selectedToEmails, cc: this.selectedCcEmails, meraki_comment_to_client: this.meraki_comment_to_client.value, email_signature: this.signature.value ?? '', update_signature: this.update_signature ? "Y" : "N", services: clientServices });
  }

  private isFormValid(): boolean {
    return this.selectedToEmails.length > 0 && this.selectedCcEmails.length > 0;
  }


  formatServiceData(formData: any) {
    return formData.services.map((service: any) => ({
      SNO: service.SNO,
      code: service.code,
      total: service.total,
      service: service.service,
      purpose: service.purpose,
      pa_remark: service.pa_remark,
      meraki_feedback: service.meraki_feedback,
      meraki_remark_client: service.meraki_remark_client,
      client_comment: service.client_comment,
      client_option: service.client_option ? "Y" : "N",
      info_msg: service.info_msg,
      agreed: service.agreed || 'N',
      negotiate: service.negotiate || 'N',
      subService: Array.isArray(service.subService) ? service.subService : [service.subService],
      display_to_client: service.display_to_client ? "Y" : "N",
    }));
  }


  selectAll(): void {
    this.selectedAll = !this.selectedAll;
    this.servicesFormArray.controls.forEach((control) => {
      control.patchValue({
        display_to_client: this.selectedAll,
      });
    });
  }
}
